export interface ExploreItem {
  id: string;
  title: string;
  description: string;
  path: string;
}

export const EXPLORE_ITEMS: ExploreItem[] = [
  {
    id: 'creators',
    title: 'Creators',
    description: 'Explore trips curated by creators you trust, save or remix them into your own perfect itinerary.',
    path: '/creators',
  },
  {
    id: 'destinations',
    title: 'Destinations',
    description: 'Discover creator-curated trips & recs by country or city.',
    path: '/destinations',
  },
  {
    id: 'travel-styles',
    title: 'Travel Styles',
    description: 'Start with a vibe and turn it into a real trip.',
    path: '/travel-styles',
  },
  {
    id: 'trending-trips',
    title: 'Trending Trips',
    description: 'The most loved creator trips, ready to save, remix or book.',
    path: '/trips',
  },
  {
    id: 'advisors',
    title: 'Advisors',
    description: 'Work with vetted travel advisors to refine and book your trip with top perks.',
    path: '/advisors',
  },
];
